import { render } from "./OffersView.vue?vue&type=template&id=1afd15cd&scoped=true"
import script from "./OffersView.vue?vue&type=script&lang=js"
export * from "./OffersView.vue?vue&type=script&lang=js"

import "./OffersView.vue?vue&type=style&index=0&id=1afd15cd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd15cd"]])

export default __exports__